import { saveAs } from 'file-saver';
import { formatCentsToUsd } from '../../../helpers/formatCentsToUsd';
import { formatDateTimeInVenueTz } from '../../../helpers/formatDateTime';
import { buildDateRangeLabel, buildFilenameRange } from '../../../helpers/excelExportHelpers';
import { getTransactionSourceLabel } from './getTransactionSourceLabel';

export const exportBookingFeeReportToXlsx = async (
    reportData,
    dateFrom,
    dateTo,
    t = (key) => key,
) => {
    const XLSX = await import('xlsx');
    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const rangeLabel = buildDateRangeLabel(dateFrom, dateTo);

    const { items = [], summary } = reportData;

    const sheetData = [
        ['Booking Fee Report'],
        [`Date Range: ${rangeLabel}`],
        [`Total bookings: ${summary?.totalBookings ?? items.length}`],
        ['Total booking fees:', formatCentsToUsd(summary?.totalFees || 0)],
        ['Total refunded fees:', formatCentsToUsd(summary?.totalRefundedFees || 0)],
        ['Total net fees:', formatCentsToUsd(summary?.totalNetFees || 0)],
        [],
        [
            'Booking ID',
            'Booking Status',
            'Show',
            'Customers',
            'Created at',
            'Source',
            'Booking Fees',
            'Refunded Fees',
            'Net Fees',
        ],
        ...items.map((r) => [
            r.bookingId,
            r.bookingStatus,
            r.showTitle,
            r.customers,
            formatDateTimeInVenueTz(r.bookingDate),
            getTransactionSourceLabel(
                {
                    transactionSource: r.source,
                    transactionAgentName: r.agentName,
                    transactionCommissionGroups: r.commissionGroups,
                },
                t,
            ),
            formatCentsToUsd(r.bookingFees),
            formatCentsToUsd(r.refundedFees),
            formatCentsToUsd(r.netFees),
        ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws['!cols'] = [
        { wch: 10 }, // Booking ID
        { wch: 14 }, // Booking Status
        { wch: 22 }, // Show
        { wch: 30 }, // Customers
        { wch: 22 }, // Created at
        { wch: 16 }, // Source
        { wch: 14 }, // Booking Fees
        { wch: 14 }, // Refunded Fees
        { wch: 12 }, // Net Fees
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Booking Fee Report');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: fileType });

    const filenameRange = buildFilenameRange(dateFrom, dateTo);
    saveAs(file, `booking-fee-report-${filenameRange}${fileExtension}`);
};

export default exportBookingFeeReportToXlsx;
